export default __webpack_public_path__ + "static/media/Z.9b14e890.svg";